/* eslint-disable */
import React, { useContext, useRef, useState, useEffect } from 'react';
import { UserContext } from '../../../App';
import { Link } from 'react-router-dom';
import styles from './ContactForm.module.css';

/**
 * Formulaire de contact partagé entre les funnels création et gestion.
 *
 * Props :
 *   title      – JSX ou string affiché dans .questions
 *   backLink   – chemin du bouton "Retour"
 *   onSuccess  – callback() déclenché après validation réussie
 *   detail     – JSX ou string affiché dans .main-details (optionnel)
 *   children   – contenu supplémentaire (optionnel) inséré sous le titre
 */
function ContactForm({ title, backLink, onSuccess, detail, children }) {
    const { company, handleChange } = useContext(UserContext);

    const firstNameRef = useRef(null);
    const lastNameRef  = useRef(null);
    const emailRef     = useRef(null);
    const phoneRef     = useRef(null);

    const [warning, setWarning] = useState([]);
    const validationComplete = useRef(false);
    const [timestamp, setTimestamp] = useState(Date.now());

    /* Marquer les champs déjà remplis au montage */
    useEffect(() => {
        [firstNameRef, lastNameRef, emailRef, phoneRef].forEach(ref => {
            if (ref.current?.checkValidity()) {
                ref.current.classList.add(styles.active);
            } else {
                ref.current?.classList.remove(styles.active);
            }
        });
    }, []);

    function handleFieldChange(event) {
        handleChange(event);
        if (event.target.checkValidity()) {
            event.target.classList.add(styles.active);
        } else {
            event.target.classList.remove(styles.active);
        }
    }

    function handleClickForm() {
        const removeIfPresent = (value) => {
            setWarning(prev => {
                const i = prev.indexOf(value);
                return i > -1 ? [...prev.slice(0, i), ...prev.slice(i + 1)] : prev;
            });
        };
        const addIfAbsent = (value) => {
            setWarning(prev => prev.includes(value) ? prev : [...prev, value]);
        };

        [firstNameRef, lastNameRef, emailRef, phoneRef].forEach(ref => {
            if (ref.current?.checkValidity()) {
                ref.current.parentElement.classList.remove(styles.invalidForm);
                ref.current.parentElement.classList.add(styles.validForm);
                removeIfPresent(ref.current.getAttribute('formvalue'));
            } else {
                ref.current.parentElement.classList.remove(styles.validForm);
                ref.current.parentElement.classList.add(styles.invalidForm);
                addIfAbsent(ref.current.getAttribute('formvalue'));
            }
        });

        validationComplete.current = true;
        setTimestamp(Date.now());
    }

    useEffect(() => {
        if (validationComplete.current && warning.length === 0) {
            onSuccess?.();
            validationComplete.current = false;
        }
    }, [warning, timestamp]);

    return (
        <div className="self-step main-9">
            <div className="global">
                <div className="questions">{title}</div>

                {children}

                <div className={`answers ${styles.answers}`}>
                    <div className={styles.list}>
                        <form id="connection-form">
                            <div className="connection">
                                {/* Ligne Prénom / Nom */}
                                <div className={`answers-row ${styles['answers-row']} ${styles.name_input}`}>
                                    <div className={`answer ${styles.answer}`}>
                                        <label className={`label ${styles.label}`} htmlFor="form.contact.firstname">
                                            Votre prénom
                                        </label>
                                        <input
                                            type="text"
                                            id="form.contact.firstname"
                                            name="form.contact.firstname"
                                            formvalue="Prénom"
                                            className={styles['form-login']}
                                            placeholder="John"
                                            value={company.form.contact.firstname}
                                            onChange={handleFieldChange}
                                            ref={firstNameRef}
                                            required
                                        />
                                    </div>
                                    <div className={`answer ${styles.answer}`}>
                                        <label className={`label ${styles.label}`} htmlFor="form.contact.lastname">
                                            Votre nom
                                        </label>
                                        <input
                                            type="text"
                                            id="form.contact.lastname"
                                            name="form.contact.lastname"
                                            formvalue="Nom"
                                            className={styles['form-login']}
                                            placeholder="Doe"
                                            value={company.form.contact.lastname}
                                            onChange={handleFieldChange}
                                            ref={lastNameRef}
                                            required
                                        />
                                    </div>
                                </div>

                                {/* Ligne E-mail / Téléphone */}
                                <div className={`answers-row ${styles['answers-row']} ${styles.coords}`}>
                                    <div className={`answer ${styles.answer}`}>
                                        <label className={`label ${styles.label}`} htmlFor="form.contact.email">
                                            Votre e-mail
                                        </label>
                                        <input
                                            type="email"
                                            id="form.contact.email"
                                            name="form.contact.email"
                                            formvalue="E-mail"
                                            className={styles['form-login']}
                                            placeholder="john@comptastar.fr"
                                            value={company.form.contact.email}
                                            onChange={handleFieldChange}
                                            ref={emailRef}
                                            required
                                        />
                                    </div>
                                    <div className={`answer ${styles.answer}`}>
                                        <label className={`label ${styles.label}`} htmlFor="form.contact.phone">
                                            Votre numéro de téléphone
                                        </label>
                                        <input
                                            type="tel"
                                            id="form.contact.phone"
                                            name="form.contact.phone"
                                            formvalue="Numéro de téléphone"
                                            className={styles['form-login']}
                                            placeholder="+33 6 07 08 09 10"
                                            value={company.form.contact.phone}
                                            onChange={handleFieldChange}
                                            ref={phoneRef}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            {warning.length > 0 && (
                                <div className={styles.warning}>
                                    Veuillez renseigner{' '}
                                    {warning.length === 1 ? 'le champ suivant' : 'les champs suivants'} :{' '}
                                    {warning.join(', ')}
                                </div>
                            )}

                            <div onClick={handleClickForm} className={`cta ${styles.cta}`}>
                                Continuer
                            </div>
                        </form>
                    </div>
                </div>

                {detail && (
                    <div className="main-details">
                        <div className="details">{detail}</div>
                    </div>
                )}

                <div className="actions">
                    <Link to={backLink}>
                        <div className="prev"><div className="arrow"></div>Retour</div>
                    </Link>
                    <div className="next" style={{ display: 'none' }}>Continuer</div>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;
